import React from 'react'

const WasWirMachen = () => {


   const services = [
  {
    title: "WEBDESIGN",
    description: "Individuelle Designs, die Ihre Marke widerspiegeln. Wir gestalten nutzerzentrierte Oberflächen für ein unvergessliches digitales Erlebnis.",
    image: "images/webdesign-agentur-performance.jpg"
  },
  {
    title: "WEBENTWICKLUNG",
    description: "Wir gestalten nicht nur Websites, wir erschaffen digitale Erlebnisse. Durch eine perfekte Kombination aus User Experience (UX) und modernstem Code entwickeln wir responsive Plattformen, die auf allen Endgeräten überzeugen.",
    image: "images/webentwicklung-agentur-performance.jpg"
  },
  {
    title: "WORDPRESS ENTWICKLUNG",
    description: "Nutzen Sie die Flexibilität des weltweit führenden CMS. Wir entwickeln individuelle WordPress-Themes und Plugins, die exakt auf Ihre Bedürfnisse zugeschnitten sind – schnell, sicher und skalierbar.",
    image: "images/maßgeschneiderte-wordpress-entwicklung-agentur.jpg"
  },
  {
    title: "COPYWRITING",
    description: "Texte, die verkaufen. Wir erstellen psychologisch fundierte Werbetexte, die Ihre Zielgruppe direkt ansprechen und zur Handlung bewegen.",
    image: "images/copywriting-und-content-marketing-strategie.png"
  },
  {
    title: "CONTENT WRITING",
    description: "Hochwertige Redaktion von Inhalten. Wir produzieren informativen und wertvollen Content, der Ihre Expertise unterstreicht.",
    image: "images/content-marketing-strategie.jpg"
  },
  {
    title: "SEO OPTIMIERUNG",
    description: "Maximale Sichtbarkeit bei Google. Wir optimieren Ihre technische Struktur und Inhalte für Spitzenplatzierungen in den Suchergebnissen.",
    image: "images/seo-analyse-google-ranking-optimierung.png"
  },
  {
    title: "E-COMMERCE SOLUTIONS",
    description: "Komplette Onlineshops mit Shopify oder WooCommerce. Skalierbare Lösungen, die perfekt auf Ihr Geschäftsmodell zugeschnitten sind.",
    image: "images/shopify-woocommerce-online-shop-loesungen.jpg"
  },
  {
    title: "EMAIL MARKETING",
    description: "Bauen Sie eine nachhaltige Beziehung zu Ihrer Zielgruppe auf. Wir entwickeln automatisierte Kampagnen und Newsletter-Strategien, die Ihre Öffnungsraten maximieren und den Customer Lifetime Value steigern.",
    image: "images/email_Marketing.jpg"
  }
];


  return (
    <div className="max-w-7xl mx-auto px-4 mt-10">

      {/* Überschrift und Einleitungstext */}
      <div className="max-w-3xl mb-16 space-y-6">
        <h2 className="text-4xl md:text-5xl font-black text-secondary leading-tight">
          Ihre Vision, unsere <span className="text-primary">digitale Exzellenz</span>
        </h2>
        
        <p className="text-slate-600 text-xl leading-relaxed">
          Wir setzen auf <span className="font-bold text-secondary">ergebnisorientiertes Webdesign</span>, 
          um Ihre Marke nachhaltig im digitalen Raum zu stärken. Durch <span className="font-bold text-secondary">nutzerzentrierte Entwicklung</span> und 
          gezielte <span className="font-bold text-secondary">Konversionsoptimierung</span> verwandeln wir 
          Besucher in treue Kunden und schaffen digitale Erlebnisse, die wirken.
        </p>
        
        {/* Dekorative Linie unter der Einleitung */}
        <div className="w-20 h-2 bg-primary rounded-full"></div>
      </div>

      {/* Grille de services avec style professionnel */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-20 mt-24">
        {services.map((item, index) => (
          <div 
            key={index} 
            className="group relative border-2 border-slate-100 p-8 pt-12 rounded-3xl flex flex-col space-y-6 transition-all duration-500 hover:border-primary/30 hover:shadow-2xl hover:shadow-primary/5 bg-white"
          >
            {/* Conteneur de l'image centrée sur la bordure supérieure */}
            <div className="absolute -top-12 left-1/2 -translate-x-1/2 md:left-12 md:translate-x-0 transition-transform duration-500 group-hover:-translate-y-2">
              <div className="relative">
                <img 
                  src={item.image} 
                  alt={item.title} 
                  className="h-24 w-24 bg-white border-2 border-secondary/20 p-3 rounded-full shadow-xl object-contain group-hover:border-secondary transition-colors duration-500" 
                />
                {/* Petit effet de halo décoratif derrière l'image */}
                <div className="absolute inset-0 bg-secondary/10 rounded-full blur-2xl -z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>
            </div>
            
            <h3 className="text-2xl font-extrabold text-secondary tracking-tight pt-4 group-hover:text-primary transition-colors duration-300">
              {item.title}
            </h3>
            
            <p className="text-slate-500 text-lg leading-relaxed transition-colors duration-300 group-hover:text-slate-700">
              {item.description}
            </p>
            
            {/* Ligne décorative discrète en bas de carte */}
            <div className="w-12 h-1 bg-slate-100 group-hover:w-full group-hover:bg-primary/20 transition-all duration-700 rounded-full"></div>
          </div>
        ))}
      </div>
    </div>

  )
}

export default WasWirMachen